import { Descriptions, Divider } from "antd";
import CommonTable from "commons/CommonTable";
import SelectField from "commons/Forms/antFields/SelectField";
import { FC, useState } from 'react';
import { FormatDate } from "utils/helpers/date_helpers";
import { getGeomTypeLabel } from "utils/helpers/geo_helpers";
import EChart from "./chart";
import { AirTreeSimulationTableColumns } from "./tableSimulationColumns";

const ViewSimulationProjectElement = ({ project, simulationData }) => {

    const [currentDataChart, setCurrentDataChart] = useState('NPP_hourly')

    return <>
        <Descriptions
            bordered
            //title={<Title level={3} type="secondary">ID geometria: {simulationData?.uuid}</Title>}
            size={'small'}
            style={{ paddingBottom: '20px' }}
            column={{ xxl: 1, xl: 1, lg: 1, md: 1, sm: 1, xs: 1 }}
        //extra={<Button type="primary">Edit</Button>}
        >
            <Descriptions.Item label="IdProgetto">{project?.id}</Descriptions.Item>
            <Descriptions.Item label="IdElemento">{simulationData?.uuid}</Descriptions.Item>
            <Descriptions.Item label="Tipo">{simulationData?.geom_type + ' - ' + getGeomTypeLabel(simulationData?.geom_type)}</Descriptions.Item>
            <Descriptions.Item label="Data inizio simulazione">{FormatDate(project?.simulation_date_start)}</Descriptions.Item>
            <Descriptions.Item label="Data fine simulazione">{FormatDate(project?.simulation_date_end)}</Descriptions.Item>
            <Descriptions.Item label="Tree area">{simulationData?.simulation_response?.tree_area}</Descriptions.Item>
        </Descriptions>


        {simulationData?.geom_type === 3 // Simulation polygon area multi types
            ?
            simulationData?.simulation_response?.map((singleElementResponse) => {
                return <>
                    <Divider />
                    <h3>Media oraria inquinanti</h3>
                    <SelectField
                        style={{ width: '80%' }}
                        options={[
                            { value: 'NPP_hourly', label: 'Media oraria NPP' },
                            { value: 'o3tot_hourly', label: 'Media oraria O3' },
                            { value: 'PM10_flux_hourly', label: 'Media oraria PM10' },
                            { value: 'PM2_5_flux_hourly', label: 'Media oraria PM2.5' },
                            { value: 'PM1_flux_hourly', label: 'Media oraria PM1' },
                        ]}
                        onChange={(val) => setCurrentDataChart(val)}
                        placeholder='Seleziona un elemento per visualizzare il grafico...'
                        label='Media oraria inquinanti'
                        allowClear={true} />
                    <EChart datas={singleElementResponse?.[currentDataChart]} />

                    <Divider />
                    <h3>Dati simulazione</h3>
                    <CommonTable hidePagination={true} columns={AirTreeSimulationTableColumns()} data={
                        [
                            { substance: 'NPP', label: 'Assorbimento totale di CO2', um: 'Kg/m2', totm2: singleElementResponse?.NPP_tot, totTree: singleElementResponse?.NPP_tot_tree, totType: '' },
                            { substance: 'O3', label: 'Deposizione totale di O3', um: 'g/m2', totm2: singleElementResponse?.o3tot, totTree: singleElementResponse?.o3tot_tree, totType: '' },
                            { substance: 'PM10', label: 'Deposizione totale di PM10', um: 'g/m2', totm2: singleElementResponse?.PM10_flux_tot, totTree: singleElementResponse?.PM10_flux_tree, totType: '' },
                            { substance: 'PM2.5', label: 'Deposizione totale di PM2.5', um: 'g/m2', totm2: singleElementResponse?.PM2_5_flux_tot, totTree: singleElementResponse?.PM2_5_flux_tree, totType: '' },
                            { substance: 'PM1', label: 'deposizione totale di PM1', um: 'g/m2', totm2: singleElementResponse?.PM1_flux_tot, totTree: singleElementResponse?.PM1_flux_tree, totType: '' },
                            { substance: 'NO2', label: 'Assorbimento totale di NO2', um: 'g/m2', totm2: singleElementResponse?.NO2_tot, totTree: singleElementResponse?.NO2_tot_tree, totType: '' },
                            { substance: 'SO2', label: 'Assorbimento totale di SO2', um: 'g/m2', totm2: singleElementResponse?.SO2_tot, totTree: singleElementResponse?.SO2_tot_tree, totType: '' },
                            { substance: 'CO', label: 'Assorbimento totale di CO', um: 'g/m2', totm2: singleElementResponse?.CO_tot, totTree: singleElementResponse?.CO_tot_tree, totType: '' },
                        ]
                    } />
                </>
            })
            :
            <>
                <Divider />
                <h3>Media oraria inquinanti</h3>
                <SelectField
                    style={{ width: '80%' }}
                    options={[
                        { value: 'NPP_hourly', label: 'Media oraria NPP' },
                        { value: 'o3tot_hourly', label: 'Media oraria O3' },
                        { value: 'PM10_flux_hourly', label: 'Media oraria PM10' },
                        { value: 'PM2_5_flux_hourly', label: 'Media oraria PM2.5' },
                        { value: 'PM1_flux_hourly', label: 'Media oraria PM1' },
                    ]}
                    onChange={(val) => setCurrentDataChart(val)}
                    placeholder='Seleziona un elemento per visualizzare il grafico...'
                    label='Media oraria inquinanti'
                    allowClear={true} />
                <EChart datas={simulationData?.simulation_response?.[currentDataChart]} />

                <Divider />
                <h3>Dati simulazione</h3>
                <CommonTable hidePagination={true} columns={AirTreeSimulationTableColumns()} data={
                    [
                        { substance: 'NPP', label: 'Assorbimento totale di CO2', um: 'Kg/m2', totm2: simulationData?.simulation_response?.NPP_tot, totTree: simulationData?.simulation_response?.NPP_tot_tree, totType: '' },
                        { substance: 'O3', label: 'Deposizione totale di O3', um: 'g/m2', totm2: simulationData?.simulation_response?.o3tot, totTree: simulationData?.simulation_response?.o3tot_tree, totType: '' },
                        { substance: 'PM10', label: 'Deposizione totale di PM10', um: 'g/m2', totm2: simulationData?.simulation_response?.PM10_flux_tot, totTree: simulationData?.simulation_response?.PM10_flux_tree, totType: '' },
                        { substance: 'PM2.5', label: 'Deposizione totale di PM2.5', um: 'g/m2', totm2: simulationData?.simulation_response?.PM2_5_flux_tot, totTree: simulationData?.simulation_response?.PM2_5_flux_tree, totType: '' },
                        { substance: 'PM1', label: 'deposizione totale di PM1', um: 'g/m2', totm2: simulationData?.simulation_response?.PM1_flux_tot, totTree: simulationData?.simulation_response?.PM1_flux_tree, totType: '' },
                        { substance: 'NO2', label: 'Assorbimento totale di NO2', um: 'g/m2', totm2: simulationData?.simulation_response?.NO2_tot, totTree: simulationData?.simulation_response?.NO2_tot_tree, totType: '' },
                        { substance: 'SO2', label: 'Assorbimento totale di SO2', um: 'g/m2', totm2: simulationData?.simulation_response?.SO2_tot, totTree: simulationData?.simulation_response?.SO2_tot_tree, totType: '' },
                        { substance: 'CO', label: 'Assorbimento totale di CO', um: 'g/m2', totm2: simulationData?.simulation_response?.CO_tot, totTree: simulationData?.simulation_response?.CO_tot_tree, totType: '' },
                    ]
                } />
            </>
        }
    </>
}

export default ViewSimulationProjectElement;

